import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
import * as yup from "yup"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Notifications';
moduleConfig.singleItemTitle = 'Notification';
moduleConfig.url = 'notifications';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  details: {
    label: "Details",
   // url: `/${moduleConfig.url}/${id}`,
  },
  update: {
    label: "Update",
  },
  create: {
    label: "Create",
  },
}


export default moduleConfig;